import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bb6fb3a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2bb6fb3a&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&lang=css&"
import style3 from "./index.vue?vue&type=style&index=3&id=2bb6fb3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6fb3a",
  null
  
)

export default component.exports